<form [formGroup]="form" (ngSubmit)="submit()">
  <onsip-header-main>
    <onsip-header-page-title>{{
      "ONSIP_I18N.CREATE_NEW_TOPIC" | translate | sentenceCase
    }}</onsip-header-page-title>
    <onsip-header-action-bar>
      <!-- HACK onsipFormSubmit directive marks children as touched  -->
      <button
        mat-stroked-button
        color="primary"
        type="submit"
        [disabled]="saving"
        [onsipFormSubmit]="form"
      >
        <mat-icon>save</mat-icon>
        {{ saving ? ("ONSIP_I18N.SAVING" | translate) + "..." : ("ONSIP_I18N.SAVE" | translate) }}
      </button>
      <button mat-button color="primary" [routerLink]="saysoSettings" [disabled]="saving">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
    </onsip-header-action-bar>
  </onsip-header-main>
</form>

<onsip-topic-write-form
  [isAdding]="true"
  [targetDisplay]="''"
  [reps]="[]"
  [video]="true"
  [countries]="[]"
  countryAvailabilityStrategy="whitelist"
  [holidays]="[]"
  [pages]="[]"
>
</onsip-topic-write-form>

<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="footer-buttons">
    <!-- HACK onsipFormSubmit directive marks children as touched  -->
    <button
      mat-stroked-button
      color="primary"
      type="submit"
      [disabled]="saving"
      [onsipFormSubmit]="form"
    >
      <mat-icon>save</mat-icon>
      {{ saving ? ("ONSIP_I18N.SAVING" | translate) + "..." : ("ONSIP_I18N.SAVE" | translate) }}
    </button>
    <button mat-button color="primary" [routerLink]="saysoSettings" [disabled]="saving">
      {{ "ONSIP_I18N.CANCEL" | translate }}
    </button>
  </div>
</form>
